export default __webpack_public_path__ + "static/media/bg-shorten-mobile.41c34b33.svg";